import React from 'react';

function LoadingSpinner() {
  return (
      <span>Loading..</span>
  );
}

export default LoadingSpinner;
